// src/services/memberApi.js
import axios from 'axios';

// Base API configuration
const API_BASE_URL = 'https://naus-backend.onrender.com/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('memberToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear tokens and redirect to login
      localStorage.removeItem('memberToken');
      localStorage.removeItem('member');
      window.location.href = '/member-login';
    }
    return Promise.reject(error);
  }
);

// API methods
export const memberApi = {
  // Get member profile
  getProfile: () => api.get('/member/profile'),

  // Update member profile
  updateProfile: (data) => api.put('/member/profile', data),

  // Change password
  changePassword: (data) => api.post('/member/change-password', data),

  // Upload certificate
  uploadCertificate: (formData) => {
    return api.post('/member/certificates/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  // Download certificate
  downloadCertificate: (type) => {
    return api.get(`/member/certificates/${type}`, {
      responseType: 'blob'
    });
  },

  // Upload profile photo
  uploadProfilePhoto: (formData) => {
    return api.post('/member/profile/photo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  // Update privacy settings
  updatePrivacy: (showInDirectory) => {
    return api.put('/member/profile/privacy', { showInDirectory });
  },

  // Get member directory (public)
  getDirectory: (params = {}) => {
    return api.get('/member/directory', { params });
  },

  // Get single member from directory (public)
  getDirectoryMember: (membershipNumber) => {
    return api.get(`/member/directory/${membershipNumber}`);
  },

  // Verify member (public - for QR code)
  verifyMember: (membershipNumber) => {
    return api.get(`/member/verify/${membershipNumber}`);
  }
};

export default memberApi;